import ActionFactory from "./action-factory";

class Timeline {
    name;
    actionSequence;
    className;
    events;

    constructor({name, actionSequence, duration, className = 'default', events = []}) {
        this.name = name;

        this.actionSequence = actionSequence.map(props => {
            props.timeLineDuration = duration;
            return ActionFactory.create(props);
        });
        this.actionSequence.push(createEndMarker());
        this.className = className;
        this.events = events || [];

        function createEndMarker() {
            return ActionFactory.create({
                type: 'NoOperation',
                startTime: duration
            });
        }
    }

    hasActionType(type) {
        return this.actionSequence.some(action => action.type === type);
    }
}

export default Timeline;
